module.exports = __webpack_public_path__ + "img/date_range.b1354781.svg";